// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"loading-spinner_spinnerWrapper__KuSA4","spinner":"loading-spinner_spinner__QXpU6","spin":"loading-spinner_spin__XIAIl"};